module.exports = __webpack_public_path__ + "img/pic_family_S.62b82e3d.jpg";